import React from "react";
import NavMenu from "../Nav/NavMenu";
import Footer from "../footer/Footer";
import EmptySlider from "../sliders/EmptySlider";
import FlightImage from "../../assets/static/support.png";
import { Container, Row, Col, Button } from "react-bootstrap";
import njangieGroupImage from "../../assets/static/njangie/njangi_ballot.png";

function Meetings() {
  return (
    <div>
      <NavMenu></NavMenu>
      <br></br>
      <br></br>
      <EmptySlider
        title="Meeting Accounts? We’ve got you covered."
        description="Kontriman provides several ways to assist you with your meeting account – through our help center, chat support, and email. Access the support you need, whenever and wherever you need it."
        imageUrl={FlightImage}
      />
      <div>
        <Container fluid className="my-5 bg-custom">
          <Container className="container-padding">
            <Row className="flex-column flex-md-row">
              {/* Text column */}
              <Col
                md={6}
                className="order-1 order-md-2 d-flex align-items-center"
              >
                <div>
                  <h1 className="custom_heading">Meeting House Account</h1>
                  <p>
                    The Meeting House Account is designed to help churches,
                    associations, and community groups manage their collective
                    finances with transparency and ease. Whether for building
                    projects, event planning, or general operations, this
                    account supports your shared mission.
                  </p>

                  <h5 className="mt-4">Features & Benefits</h5>
                  <ul>
                    <li>Secure and transparent fund management</li>
                    <li>Multi-signatory access options</li>
                    <li>Detailed transaction statements</li>
                    <li>Support for fundraising and member contributions</li>
                  </ul>

                  <h5 className="mt-4">Eligibility</h5>
                  <ul>
                    <li>Registered group, church, or association</li>
                    <li>Group constitution or operating guidelines</li>
                    <li>Valid IDs of authorized signatories</li>
                    <li>Proof of address for the organization</li>
                  </ul>

                  <a href="mailto:info@kontriman.com">
                    <Button className="custom-button mt-3">
                      Open Meeting House Account
                    </Button>
                  </a>
                </div>
              </Col>

              {/* Image column */}
              <Col md={6} className="order-2 order-md-1">
                <img
                  src={njangieGroupImage}
                  alt="Meeting House Account"
                  className="img-fluid"
                />
              </Col>
            </Row>
          </Container>
        </Container>
      </div>
      <Footer></Footer>
    </div>
  );
}

export default Meetings;
